import { useState } from "react";
import { Container } from "react-bootstrap";
import { Skeleton } from '@mui/material';
import { NavBar, Footer, TestimonialCarousel, FooterForm, FeaturedSectors, NewButton, StartupGaining, Presenters } from "../components/index";
import { tracking } from '../../../utils/tracking';
import { useResizeImg } from '../../../utils/useResizeImg';
import styles from "./Startups.module.css";

const DESKTOP_IMG_URL = '../../../../assets/events/etvs23/startups-banner-desktop.jpg'
const MOBILE_IMG_URL = '../../../../assets/events/etvs23/startups-banner-mobile.jpg'

export const Startups = () => {
   document.title = "Emerging Tech Venture Summit | Startups";

   const [isLoading, setIsLoading] = useState(true);
   const imageSource = useResizeImg(DESKTOP_IMG_URL, MOBILE_IMG_URL)

   return (
      <div>
         <NavBar />
         <Container className={styles.banner} fluid>
            {isLoading ?
               <Skeleton animation="wave" variant="rectangular" sx={{ minHeight: imageSource === DESKTOP_IMG_URL ? '65vh' : '100vh', position: 'initial !important', backgroundColor: '#0F1A28' }}>
                  <div id="etxLoader" style={{ left: window.innerWidth > 900 ? '45%' : '40%', top: '40%' }} />
                  <img
                     onLoad={() => setIsLoading(false)}
                     src={imageSource}
                     alt='home-img'
                     style={{ visibility: 'hidden', minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
                  />
               </Skeleton>
               :
               <img
                  src={imageSource}
                  loading="eager"
                  alt='home-img'
                  style={{ minHeight: window.innerWidth > 1200 && "50vh", width: '100%' }}
               />
            }
            {
               !isLoading &&
               <div className={styles.itemsOnImg}>
                  <h2>Featured Companies</h2>
                  <h2>Get Noticed. Get Funded. Grow Faster</h2>
                  <a href='https://account.youngstartup.com' onClick={() => tracking(283)} className={styles.btn}>
                     <NewButton name='APPLY NOW' color='#CF1B5B' bgColor='white' borderColor='none' fontSize />
                  </a>
                  <br />
               </div>
            }
         </Container>
         <FeaturedSectors /> 
         <StartupGaining />
         <TestimonialCarousel bg={'linear-gradient(180deg, #5F3D5A 0%, #9D6C88 100%)'} pageName={"startups;"} iconsColor={'#A66389'} />
         {/* <Presenters /> */}
         <FooterForm />
         <Footer />
      </div >
   );
};
